import { cn } from '@/lib/utils'

interface TickerDropOverlayProps {
  isDragging: boolean
  isOver: boolean
  label: string
  className?: string
}

/**
 * Drop-target feedback for a ticker drag: a faint dashed outline on every
 * target while a ticker is in flight, solid with a label on the one under
 * the cursor. Pointer-transparent; the parent must be positioned.
 */
export function TickerDropOverlay({
  isDragging,
  isOver,
  label,
  className,
}: TickerDropOverlayProps) {
  if (!isDragging) return null
  return (
    <div
      aria-hidden
      data-testid="ticker-drop-overlay"
      className={cn(
        'pointer-events-none absolute inset-0 z-40 rounded-sm border-2 border-dashed transition-colors',
        isOver ? 'border-primary bg-primary/10' : 'border-primary/30',
        className,
      )}
    >
      {isOver && (
        <div className="absolute inset-x-0 top-1/2 flex -translate-y-1/2 justify-center">
          <span className="rounded-md bg-primary px-2.5 py-1 text-xs font-medium text-primary-foreground shadow-lg">
            {label}
          </span>
        </div>
      )}
    </div>
  )
}
